import type { FaireProductEntity } from "../../entity_types/product";

export const p_8qy96m2mns: FaireProductEntity = {
  token: "p_8qy96m2mns",
  type: "product",
  name: "'Everything Goes My Way' persimmon cat lampwork glass figurine",
  brandToken: "b_xwg3rhcf7n",
  brandName: "ShangDaili",
  imageUrl:
    "https://cdn.faire.com/fastly/22b1aefa3156927fe69ce41ac72e0e0f7268d599705af370aea58972a0cf59df.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1f3fe2f2fa61f12e53bbf5842297112d966664dbac21b9f83aabf99a4a500655.jpeg",
    "https://cdn.faire.com/fastly/4a48161addd81017a2fefe9110f4205ae83517aea77fb8641fb72fa5f2665b6e.jpeg",
    "https://cdn.faire.com/fastly/284c0085ec0d2d9a4d248170949394abd897d689c0767f66e4ccca38639cdeff.jpeg",
    "https://cdn.faire.com/fastly/82d5cf47629930c6b934ad2f66153b220ea6dffffc1b759d869bee05a9503608.jpeg",
  ],
  priceDollars: 21.5,
  description:
    '"柿柿如意" puns to "everything goes my way" in Chinese. Persimmons symbolize fortune and success due to their round shape, and are believed to bring good luck.\n\nBesides the culture part which appears to be superstitious, this figurine serves as a token to remind us to focus our mind to create a new mindset, which them leads to actions that make our goal reality. This process activates specific neural pathways, encourages the brain to subconsciously seek opportunities related to the goal. Our action follows our mind.\n\nIn addition, micro dose of dopamine is guaranteed when you look at this little guy.',
  tags: [],
  msrpDollars: 43,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:37.695Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
